import { Product } from '../types/Product';
import { MenuOptions } from '../types/Menu';
import { apiService } from '../services/apiService';
import { generateRecipePrompt } from './recipe/recipePrompts';

export const generateRecipeSteps = async (
  products: Product[],
  menuName: string,
  options: MenuOptions
): Promise<string> => {
  try {
    const prompt = generateRecipePrompt(products, menuName, options);
    const response = await apiService.generateRecipe(prompt);
    return response.choices[0].message.content;
  } catch (error) {
    console.error('Error generating recipe steps:', error);
    return 'Lo siento, no se pudieron generar los pasos de la receta. Por favor, inténtalo de nuevo.';
  }
};